import React from 'react'
import { Layout, Menu } from 'antd'
import { useAppSelector } from '@/store/hooks'
import { generateMenuItems } from '@/utils/menu'
import type { MenuProps } from 'antd'

const { Sider: AntSider } = Layout

interface SidebarProps {
  collapsed: boolean
  currentTheme: 'light' | 'dark'
  selectedKeys: string[]
  openKeys: string[]
  onOpenKeysChange: (keys: string[]) => void
  onMenuClick: MenuProps['onClick']
  isMobile?: boolean
  mobileMenuOpen?: boolean
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  currentTheme,
  selectedKeys,
  openKeys,
  onOpenKeysChange,
  onMenuClick,
  isMobile = false,
  mobileMenuOpen = false,
}) => {
  const { menus } = useAppSelector((state) => state.user)
  
  const menuItems = generateMenuItems(menus, () => {})

  return (
    <AntSider
      trigger={null}
      collapsible
      collapsed={collapsed}
      className={`admin-sider ${isMobile && mobileMenuOpen ? 'mobile-open' : ''}`}
      theme={currentTheme}
    >
      <div className="admin-logo">
        <h2>{collapsed ? 'A' : 'Admin'}</h2>
      </div>
      <Menu
        theme={currentTheme}
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={onOpenKeysChange}
        onClick={onMenuClick}
        items={menuItems}
        className="admin-menu"
      />
    </AntSider>
  )
}

export default Sidebar

